<div class="w-575">
  <div mat-dialog-title>
    <div class="modal__header">
      <div class="modal__title">
        <h1>{{ title }}</h1>
      </div>
      <div class="mt-2 w-450">
        <span>{{ description }}</span>
      </div>
      <button
        class="close-button"
        mat-dialog-close>
        <i class="material-symbols-rounded">close</i>
      </button>
    </div>
  </div>

  <mat-dialog-content class="modal-container generic-modal">
    <ng-container *ngIf="!isTrafficking">
      <div class="px-10 pb-4 w-full generic-modal__content">
        <div class="flex items-center justify-between mb-5">
          <scope-ui-input
            icon="search"
            inputPlaceholder="Find {{ 'scope' | lang }}"
            inputClass="traffic-search"
            class="w-full"
            (onInputChange)="onSearch($event)" />

          <span class="traffic-counter ml-4"> {{ getSelectedScopes().length }} / {{ MAX_SELECTED_SCOPES }} </span>
        </div>

        <scope-ui-checkbox
          title="Select All"
          [ngModel]="isAllSelected"
          (ngModelChange)="selectAll()" />

        <div class="traffic-list">
          <div
            *ngFor="let scope of scopes | filter: searchString : 'name'; trackBy: trackById"
            class="ml-4">
            <scope-ui-checkbox
              [title]="scope.name"
              [disabled]="isDisabled"
              [(ngModel)]="scope.selected" />
          </div>
        </div>
      </div>

      <div class="d-flex d-flex-justify-end px-10 pt-8 pb-4">
        <div class="generic-modal__buttons">
          <button
            mat-button
            mat-dialog-close>
            Cancel
          </button>
          <button
            class="main-action-button ml-4"
            mat-button
            (click)="traffic()">
            Confirm
          </button>
        </div>
      </div>
    </ng-container>

    <ng-container *ngIf="isTrafficking">
      <div class="px-10 pb-4 w-full generic-modal__content">
        <div
          *ngFor="let scope of getSelectedScopes()"
          class="traffic-status">
          <i
            *ngIf="trafficStatus?.[scope.identity.id].processing"
            class="material-symbols-rounded traffic-rotate">
            sync
          </i>
          <ng-container *ngIf="!trafficStatus?.[scope.identity.id].processing">
            <i
              *ngIf="!trafficStatus?.[scope.identity.id].failed && !trafficStatus?.[scope.identity.id].completed"
              class="material-symbols-rounded">
              check_circle
            </i>
            <i
              *ngIf="trafficStatus?.[scope.identity.id].failed"
              class="material-symbols-rounded text-red-500">
              clear
            </i>
            <i
              *ngIf="trafficStatus?.[scope.identity.id].completed"
              class="material-symbols-rounded green">
              check_circle
            </i>
          </ng-container>
          <span class="ml-2">{{ scope.name }}</span>
          <span
            *ngIf="trafficStatus?.[scope.identity.id].error as error"
            class="ml-2 text-red-500">
            Error: {{ error }}
          </span>
        </div>
      </div>

      <div
        *ngIf="isTrafficking"
        class="d-flex d-flex-justify-end px-10 pt-8 pb-4">
        <div class="generic-modal__buttons">
          <button
            mat-button
            mat-dialog-close
            [disabled]="!isDone">
            {{ isDone ? 'Cancel' : 'Processing...' }}
          </button>
        </div>
      </div>
    </ng-container>
  </mat-dialog-content>
</div>
